// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n@media screen and (max-width: 600px) {\n.espaço-desktop[data-v-059d3b68] {\n    display: none;\n}\n}\n@media screen and (max-width: 600px) {\n.btn-container[data-v-059d3b68] {\n    margin-right: 0;\n}\n}\n@media screen and (min-width: 900px) {\n.btn-container[data-v-059d3b68] {\n    width: 150px;\n    margin-right: auto;\n}\n}", ""]);
// Exports
module.exports = exports;
